import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {createLazyComponent} from 'helpers/createLazyComponent'
import React, {useContext} from 'react'
import createStickySider from 'views/AppLocals/factory/createStickySider'

// Lazy-loaded: AppGroupBlock kéo theo discoveryMapExplorerRouteEntities -> createDiscoveryExplorer,
// vốn import ngược lại `gPaths` từ views/AppLocals/configs (nơi UserFeatureMenu được khai báo) ->
// import tĩnh ở đây sẽ tạo circular import (TDZ error khi load configs.js). Lazy load để phá vòng lặp.
const blockFallback = <div className="w-full h-24 background-200 rounded-xl animate-pulse"/>

const AppGroupBlock = createLazyComponent(
    () => import('views/MainPage/Space/container/AppGroupBlock').then((m) => ({default: m.AppGroupBlock})),
    blockFallback
)
const CategoriesBlock = createLazyComponent(
    () => import('views/MainPage/Space/container/CategoriesBlock').then((m) => ({default: m.CategoriesBlock})),
    blockFallback
)
const ChannelBlock = createLazyComponent(
    () => import('views/MainPage/Space/container/ChannelBlock').then((m) => ({default: m.ChannelBlock})),
    blockFallback
)

const Content = () => {
    const {isLg} = useContext(LayoutContext)

    if (!isLg) return null

    return (
        <div className="flex flex-col gap-6 mt-6">
            <AppGroupBlock/>
            <CategoriesBlock/>
            <ChannelBlock/>
        </div>
    )
}

const UserFeatureMenu = ({Wrapper = 'div', stickySider = true}) =>
    createStickySider({
        Wrapper,
        stickySider,
    })(Content)

export default UserFeatureMenu
